var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", [_c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Is Primary",
      prop: "isPrimary"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.isPrimary,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "isPrimary", $$v);
      },
      expression: "formData.isPrimary"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Is Postal",
      prop: "isPostal"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.isPostal,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "isPostal", $$v);
      },
      expression: "formData.isPostal"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Name",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Name"
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Line 1",
      prop: "line1"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.formData.line1,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "line1", $$v);
      },
      expression: "formData.line1"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Line 2",
      prop: "line2"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.formData.line2,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "line2", $$v);
      },
      expression: "formData.line2"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "City",
      prop: "cityName"
    }
  }, [_c("div", {
    staticClass: "city-select-container"
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.cityListLoading,
      "loading-text": "fetching cities..",
      "remote-method": _vm.getCityList,
      placeholder: "Select City"
    },
    model: {
      value: _vm.formData.cityName,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "cityName", $$v);
      },
      expression: "formData.cityName"
    }
  }, _vm._l(_vm.cityList, function (city) {
    return _c("el-option", {
      key: city.id,
      attrs: {
        label: city.name,
        value: city.name
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(" " + _vm._s(city.name) + " ")])]);
  }), 1), _c("el-button", {
    staticStyle: {
      "margin-left": "7px"
    },
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.dialogFormVisible = true;
      }
    }
  }, [_vm._v(" Add City ")])], 1)]), _c("el-dialog", {
    attrs: {
      title: "Add City",
      visible: _vm.dialogFormVisible
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form
    }
  }, [_c("el-form-item", {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      label: "States",
      "label-width": _vm.formLabelWidth,
      required: ""
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "Select a state",
      clearable: ""
    },
    model: {
      value: _vm.form.stateId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "stateId", $$v);
      },
      expression: "form.stateId"
    }
  }, _vm._l(_vm.stateList, function (state) {
    return _c("el-option", {
      key: state.id,
      attrs: {
        label: state.name,
        value: state.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "City name",
      "label-width": _vm.formLabelWidth
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off"
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.dialogFormVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitDialog
    }
  }, [_vm._v(" Add ")])], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "GST",
      prop: "gstNumber"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter GST"
    },
    model: {
      value: _vm.formData.gstNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "gstNumber", $$v);
      },
      expression: "formData.gstNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "PAN",
      prop: "panNumber"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter PAN"
    },
    model: {
      value: _vm.formData.panNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "panNumber", $$v);
      },
      expression: "formData.panNumber"
    }
  })], 1), _c("el-form-item", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      label: "Enter Pincode",
      prop: "pincodeId"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      remote: "",
      "remote-method": _vm.getPincodeList,
      name: "Pincode",
      placeholder: "Enter Pincode Name"
    },
    model: {
      value: _vm.formData.pincodeId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "pincodeId", $$v);
      },
      expression: "formData.pincodeId"
    }
  }, _vm._l(_vm.pincodeList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.pincode,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1)], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };